import { render, staticRenderFns } from "./displayReadingBasicInfo.vue?vue&type=template&id=e4a865ae"
import script from "./displayReadingBasicInfo.ts?vue&type=script&lang=js&external"
export * from "./displayReadingBasicInfo.ts?vue&type=script&lang=js&external"
import style0 from "./displayReadingBasicInfo.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports